// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
require('./table.scss');

const deps = [];

module.exports = angular.module('bench.ui.table', deps);
